export const ZoomInIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="7.5" cy="7.5" r="5.5" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M12 12L16 16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M7.5 5v5M5 7.5h5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);
